import {
    deleteBillingCodeLoading,
    deleteBillingCodeRequest,
    deleteBillingCodeSuccess,
    deleteBillingCodeReject,
    deleteBillingCodeReset,
} from "../../actions/billingCode/delete";

export const deleteBillingCode = (formData) => async (dispatch, getState) => {
    dispatch(deleteBillingCodeLoading());
    try {
        const { data } = await deleteBillingCodeRequest(formData, getState);
        dispatch(deleteBillingCodeSuccess(data))
    } catch (error) {
        dispatch(deleteBillingCodeReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteBillingCodeReset()) }, 3000);
    }
    return Promise.resolve();
};
